import React, { Component } from 'react'


import Drawer from "../Drawer/Drawer";
import history from 'routes/History/history';
import { Switch, Route, Redirect } from "react-router-dom";
import dashboardRoutes from "routes/dashboardRoutes"
import { onRouteChange } from "../../reducers/application/applicationActions";
import { connect } from "react-redux";
import B2C_LINK from "utils/HttpClient/b2cLink"
import TOOLS_LINK from "utils/HttpClient/toolsLink"

class MainContainer extends Component {

    menu = [
        { name: "Mi red", path: '/tree', selected: false, icon: "supervised_user_circle", external: false },
        { name: "Proyectos", path: '/projects', selected: false, icon: "layers", external: false },
        { name: "Nueva Afiliación", path: '/sale', selected: false, icon: "person_add", external: false },
        { name: "Afiliaciones", path: '/sales', selected: false, icon: "group", external: false },
        { name: "Reportes", path: '/widgets', selected: false, icon: "widgets", external: false },
        { name: "Herramientas", path: TOOLS_LINK, selected: false, icon: "build", external: true },
        { name: "Mi Billetera", path: '/wallet', selected: false, icon: "monetization_on", external: false },
        { name: "Pagar con Tarjeta", path: B2C_LINK, selected: false, icon: "credit_score", external: true },
        { name: "Pago con QR", path: 'https://api.whatsapp.com/send?phone=59176660421', selected: false, icon: "qr_code", external: true }
    ];



    constructor(props) {
        super(props);
        this.threshold = window.innerWidth > 756
    }

    onMenuClick(i) {
        // alert(this.menu[i]);
        history.push(this.menu[i].path);
    }

    redirectToDashBoardClick = () => {
        history.push("/");
    };

    render() {
        console.dir(this.props.currentRoute.location.pathname);
        this.menu.map((e) => { e.selected = e.path === this.props.currentRoute.location.pathname });
        let isDesktop = this.threshold;
        let contentClass = isDesktop ? "" : "main-content-with-navbar";
        let arr = window.location.href.split("/");
        let showFooter = arr[arr.length - 1] !== "tree";
        return (
            <Drawer menuItems={this.menu}
                threshold={isDesktop}
                redirectToDashBoardClick={() => this.redirectToDashBoardClick()}
                onMenuSelected={(i) => this.onMenuClick(i)}>
                <div id="main-content" className={contentClass}>
                    <div className="main-container container">
                        <Switch>
                            {dashboardRoutes.map((prop, key) => {
                                if (prop.redirect) {
                                    return (
                                        <Redirect from={prop.path} to={prop.pathTo} key={key} />
                                    )
                                } else {
                                    return <Route key={key}
                                        path={prop.path}
                                        data={prop}
                                        component={prop.component} />
                                }
                            }
                            )}
                        </Switch>
                    </div>
                </div>
            </Drawer>
        )
    }
}

const mapStateToProps = state => ({
    currentRoute: state.application.currentRoute
});

export default connect(mapStateToProps, { onRouteChange })(MainContainer);



// WEBPACK FOOTER //
// ./src/components/MainContainer/MainContainer.jsx